import React from "react";
import {Link} from "react-router-dom";
import {Image} from "antd";
import ForgotPassword from "../../page-components/auth/forgot-password/forgot-password";
import "../../styles/component/auth/forgot-password.scss";

const ForgotPasswordPage = () => {
    return (
        <div className="forget-password">
            <div className="forget-password-section">
                <div className="forget-password-title">
                    <Image
                        preview={false}
                        src={`${process.env.REACT_APP_IMAGE_BASE_URL}/icons/people-nest-logo.svg`}
                        alt="people-nest-logo"
                        className="hrms-logo"
                    />
                    <h3 className="heading">Forgot Password?</h3>
                </div>
                <ForgotPassword/>
            </div>
        </div>
    )
}

export default ForgotPasswordPage;